'use strict';

import React from 'react'

import Loader from '@Pure/Loader'

import Modal  from '@Modal/Modal'

import FormElement from '@/Form/toolkit/FormElement'

import { handleChange } from '@/Form/Functions/eventsHandling'

let app = window.app;

export default class ProviderOrderMassActionModal extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			open: false,
			data: { },
			form_data: { },
			status_messages: { }
		};

		this.handleClose = this.handleClose.bind(this);
		this.validate    = this.validate.bind(this);
		this.open        = this.open.bind(this);

		this.handleChange = handleChange.bind(this);
	}

	componentWillMount ()
	{
		const component = this, props = this.props;

		app.push(
		{
			type: 'listener',
			event: 'open__ProviderOrderMassActionModal',
			cb: component.open
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			type: 'listener',
			event: 'open__ProviderOrderMassActionModal',
			cb: component.open
		});
	}

	handleClose (e, force)
	{
		const component = this, props = this.props;

		if (component.state.loading === true && !force)
		{
			e.stopPropagation();
			return;
		}

		component.setState(
		{
			open: false,
			loading: false,
			data: undefined,
			form_data: { }
		});
	}

	open (params)
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			open : true,
			data: params.data,
			action: params.action,
			form_data: { 'number': params.number || '' }
		});
	}

	validate (e)
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			loading: true
		});

		let data =
		{
			data: state.data,
			action: state.action,
			number: state.form_data['number']
		};

		qwest.post('/provider-order/mass-action', data)
		.then(function (xhr, response)
		{
			app.emit('providerOrdersMassAction', data);

			component.handleClose(e, true);
		})
		.catch(function (error, xhr, response)
		{
			console.error(error, response);

			app.ajaxRedirectLogin(response);
		});
	}

	render ()
	{
		const props = this.props, component = this, state = this.state;

		let loader, warning;

		if (component.state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['secondary', 'bg-white'] } />;
		}

		let apply =
		(
			<button className="c-btn c-dialog__danger"
				onClick={ component.validate }>
				Appliquer à tous
			</button>
		);

		let number =
		(
			<FormElement name="number" type="text" data={ state.form_data }
				onChange={ component.handleChange } label={ 'Numéro de ' +
					(state.action === 'transaction' ? 'transaction' : 'commande') }
				status={ state.status_messages }/>
		);

		let info =
		(
			<div className="c-message c-message--orange">
				<div className="c-message__content">
					Ce numéro sera appliqué à tous les produits sélectionnées.
				</div>
			</div>
		);

		if (state.data && state.data.length === 0)
		{
			warning =
			(
				<div className="c-message c-message--orange">
					<div className="c-message__content">
						Veuillez sélectionner au moins un produit.
					</div>
				</div>
			);

			apply  = undefined;
			number = undefined;
			info   = undefined;
		}

		let output =
		(
			<Modal open={ component.state.open } onClose={ component.handleClose }
				title={ 'Saisie de numéros de ' + (state.action === 'transaction' ? 'transaction' : 'commande') } hide_close={ true }>

				{ info }

				{ number }

				{ warning }

				<div className="c-dialog__buttons">
					<button className="c-btn c-dialog__cancel"
						onClick={ component.handleClose }>
						Annuler
					</button>

					{ apply }
				</div>

				{ loader }

			</Modal>
		);

		return output;
	}
}
